export enum PlaceType {
  CONTINENT = 0,
  COUNTRY = 1,
  REGION = 2,
  RESORT = 3,
  HOTEL = 4
}
